
import React, { useEffect, useState } from "react";
import axios from "../../../../../../Services/axiosCommon";
import {Link, useLocation, useParams } from "react-router-dom";
import Pagination from "../../../../../../Components/Utils/Pagenation";
import { Button, Modal, notification, } from "antd";
import { useFormik } from 'formik';
import * as yup from "yup";
import { useNumber } from "../../../../../../Context/ProjectIdContext";
import CostingLayout from "../CostingLayout";
import ViewMore from "./ViewMore";
import NuAmount from "../../../../../../Components/Utils/NuAmount";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import { GetAccess } from "../../../../../../Components/Utils/roles";
import { NuSelect } from "../../../../../../Components/Utils/Input";
import Breadcrumb from "../../../../../../Components/Utils/Breadcrumb";
import UseGetDataSearchByPro from "../../../../../../Components/Hooks/useFetchDataByPRO";
import axiosInstance from "../../../../../../Services/axiosCommon";
import MultiEditManpowerbug from "./MultiEditManpowerpro";
import CreateManPower from "./CreateManPower";
import { CancelButton, EditButton, LongButton, SubmitButton } from "../../../../../../Components/Utils/Buttons";
import FormikSelectTwo from "../../../../../../Components/Utils/Select";
import TitleManpower from "./TilteManpower";
import { ExclamationCircleFilled } from '@ant-design/icons';
import CreateSubManpowerbug from "./CreateSubManpowerPro";
import UseCatSubCatDropDown from "../../../../../../Components/Hooks/useCategoryDropDown";
import ImportManPower from "./import";

import MobileManPower from "../../../../../Mobile/ProjectSubmenu/Budget/ManPower/MobileManpower";
import ImportEstimation from "./ImportEst";

function ManPowerCosting()  {
  // const {value:Category ,getData:getCategory} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerRole')

//   const {value:Role ,getData:refManPowerRole} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerRole')
// const {value:category ,getData:refManPowercategory} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowercategory')
const {value:Category ,getData:  refManPowerCategory} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerCategory')
    const {value:Type ,getData:  refManPowerType} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerType')
const location = useLocation();



  const { officeId } = useParams();
  const { projectId } = useParams();

const [setData] = useState([]);
const [open, setOpen] = useState(false);
const [importEstimationOpen, setImportEstimationOpen] = useState(false);
// const [pageIndex, setPageIndex] = useState(1);
// const [dataCount, setDataCount] = useState(20);
const [createModalOpen, setCreateModalOpen] = useState(false);
const [filterOpen, setFilterOpen] = useState(false);
const [isFilter,setIsFilter]= useState(false);
const [filterData,setFilterData]= useState({
   category: ""
});
 const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });
   useEffect(() => {
      const handleResize = () => {
        setScreenSize({
          width: window.innerWidth,
        });
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);


const [afterFilter,setAfterFilter]= useState({})

const [totalData, setTotalData] = useState(0);
const { confirm } = Modal;
const [api, contextHolder] = notification.useNotification();
const [multiEditOpen, setMultiEditOpen] = useState(false);
const [selectedTitles, setSelectedTitles] = useState([]);
const [selectedExpandedItems, setSelectedExpandedItems] = useState([]);
const [flatSelectedItemIds, setFlatSelectedItemIds] = useState([]);

const handleMainCheckboxChange = (titleId, items) => {
  setSelectedTitles((prevSelectedTitles) =>
    prevSelectedTitles.includes(titleId)
      ? prevSelectedTitles.filter((id) => id !== titleId)
      : [...prevSelectedTitles, titleId]
  );

  setSelectedExpandedItems((prevSelectedExpandedItems) => ({
    ...prevSelectedExpandedItems,
    [titleId]: selectedTitles.includes(titleId)
      ? [] // Clear items if main checkbox is deselected
      : items.map(item => item.id), // Select all items if main checkbox is selected
  }));
};

const handleExpandedCheckboxChange = (titleId, itemId) => {
  setSelectedExpandedItems((prevSelectedExpandedItems) => ({
    ...prevSelectedExpandedItems,
    [titleId]: prevSelectedExpandedItems[titleId]?.includes(itemId)
      ? prevSelectedExpandedItems[titleId].filter((id) => id !== itemId)
      : [...(prevSelectedExpandedItems[titleId] || []), itemId],
  }));
};

useEffect(() => {
  const allSelectedIds = Object.values(selectedExpandedItems).flat();
  setFlatSelectedItemIds(allSelectedIds);
}, [selectedExpandedItems]);


const searchQuery= location.state?.searchQuery
const currentPage= location.state?.currentPage
const [page, setPage] = useState(currentPage||1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
   const [showFilterDialog, setShowFilterDialog] = useState(false);
    const [filter, setFilter] = useState(false);
   
     const [filterProps, setFilterProps] = useState({
     
       category:"",
       
     });
    
 const [params, setParams] = useState({
      page: page,
      per_page: pageCount,
      search:searchQuery||"",
  
      category:"",
       });
       const clearFilter = ()=> {
        setParams({...params, 
          category:"",
         })
         formik.values.category=""   
         setFilter(false)
     }
      const formik = useFormik({
         enableReinitialize: true,
         initialValues: filterProps,
         validateOnChange: false,
         validateOnBlur: false,
         validationSchema: yup.object({
           // email: yup.string().required('Email is required!'),
         }),
         onSubmit: async (value, { resetForm }) => {
           setParams({...params, category:value.category})
           closeFilterDialog();
           setFilter(true)
           setFilterProps({
             category:"",
        
           });
         }
       })

   const { data, totalCount, getData,dataLoading } = UseGetDataSearchByPro( `/man_power_cost/new/${projectId}`,params);
    useEffect(()=>{
        setParams({...params,page:page,per_page:pageCount})
       },[page,pageCount])
  //   useEffect(() => {
  //     setParams(prevParams => ({
  //         ...prevParams,
  //         page: page,
  //         per_page: pageCount
  //     }));
  // }, [page, pageCount]);

 const closeFilterDialog = () => {
   setShowFilterDialog(false);
 };
const isTitleSelected = (titleId) => selectedTitles.includes(titleId);



const handleDelete = async(id) =>{
  confirm({
      title: `Do you Want to delete ManPower Items?`,
      centered:true,
      width:"25%",
      icon: <ExclamationCircleFilled />,
      content: `The ManPower Items will be removed from the ManPower`,
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps: {
        style: { backgroundColor: '#048178', color: 'white' }, 
      },
      onOk() {
        axiosInstance.delete(`/pro_manpower/multi-delete`, {
          headers: {
            'Content-Type': 'application/json',
          },
          data: { "ids": id } // Pass the payload as the `data` key in `delete`
        }).then((res) => {
          if(res.status === 201||res.status === 200) {
            getData();
              api.success({
                message: `ManPower Multi Item has deleted successfully`,
                description:res?.data?.msg||' ',
                placement: 'bottomRight',
              });
          } else{
              api.error({
                  message: `ManPower Multi Item has delete failed`,
                  description:res?.data?.msg||'Network error',
                  placement: 'bottomRight',
                });
          }
          })
          .catch((error) => {
              api.error({
                  message: `ManPower Multi Item has delete failed`,
                  description:error?.response?.data?.msg||'Sever error (or) Network error',
                  placement: 'bottomRight',
                });
          });
      },
      onCancel() {
      },
    });
}
const [valueOfSearch,setValuesofSearch] = useState("")
function searchFunction(e) {

  
  setValuesofSearch(e?.target?.value)
  setParams({ ...params, search: e?.target?.value, page:1 });
  setPage(1)
}


const { category: itemsCategory, subCategory: itemsSubCategory } =UseCatSubCatDropDown("/category/ItemCategory","ItemCategory",formik?.values?.category);
 
 

return (
  <>
  {contextHolder}
  <CostingLayout
    setOpen={setOpen}
    setImportEstimationOpen={setImportEstimationOpen}
    onCreateClick={()=>{setCreateModalOpen(true)}}
    isFilter={filter}
    setFilterOpen={setShowFilterDialog}
    ClearFilter={clearFilter}
    searchFun={searchFunction}
    searchValue={valueOfSearch}
    newfilter={true}
    ImportEstAccess={true}
    officeId={officeId}
    searchQuery={searchQuery} 
    neededSearch={true}
    projectId={projectId}
  >
              <div className="w-full h-[calc(100vh-153px)] p-3 overflow-hidden">
              {screenSize.width<="786"?<MobileManPower  Data={data} getData={getData} itemsCategory={itemsCategory} Type={Type}

               />:
        <div className=" w-full h-[calc(100vh-195px)] overflow-y-scroll">
        {flatSelectedItemIds.length > 0 ? 
          <div className="w-full flex justify-end gap-2 py-2">
          <EditButton height='5' value="Multi Edit" handleClick={() => { setMultiEditOpen(true) }}/>
          <button
            type='button'
            className="px-2 h-5 cursor-pointer text-xs text-red-500 bg-white rounded-md flex items-center"
            style={{ border: "1px solid red" }}
            onClick={() => {handleDelete(flatSelectedItemIds)}}
          >
            Multi Delete
          </button>
        </div>
          :
          null
          }
          
          <table
            className="table-auto static top-0 w-full"
            style={{ border: "none", borderCollapse: "collapse" }}
          >
            <thead className=" w-full bg-white p-3 mt-4">
              <tr className="text-xs border-b  font-medium  py-3">
                {header.map((header, i) => (
                  <th
                    className={`py-3 ${header.width}  ${
                      header?.isLeft ? "text-left" : "text-center"
                    } font-medium text-xs 2xl:text-sm text-[#4F4768]`}
                    key={i}
                    style={{ border: "none", borderCollapse: "collapse" }}
                  >
                    {header.headone}
                  </th>
                ))}
              </tr>
            </thead>
          </table>
              
      
          <div className={` w-full pt-0.5 ${flatSelectedItemIds.length > 0 ? "h-[calc(100vh-250px)]" : "h-[calc(100vh-243px)]"}  overflow-y-auto relative`}>
            <table
              className="table-auto  w-full"
              style={{ border: "none", borderCollapse: "collapse" }}
            >
              <tbody>
                {data &&
                  data.map((item, i) => {
                    return (
                      <TitleManpower
                        data={item}
                        itemsCategory={itemsCategory}
                        // role={Role}
                        Category={Category}
                        Type={Type}
                        getData={getData}
                        projectId={projectId}
                        selectedTitles={selectedTitles}
                        selectedExpandedItems={selectedExpandedItems}
                        onMainCheckboxChange={handleMainCheckboxChange}
                        onExpandedCheckboxChange={
                          handleExpandedCheckboxChange
                        }
                        isTitleSelected={isTitleSelected}
                        // getCategory={getCategory}
                        // refManPowerRole={refManPowerRole}
                        // refManPowercategory={refManPowercategory}
                        refManPowerCategory={refManPowerCategory}
                        refManPowerType={refManPowerType}
                      />
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
}
        <div className=" my-[2px] px-3">
          <Pagination
                        total={totalCount}
                        pageIndex={params.page}
                        setPageIndex={setPage}
                        dataCount={params.per_page}
                        setDataCount={setPageCount}
                     />
        </div>
      </div>
      <CreateManPower
        open={createModalOpen}
        onCancel={() => {
          setCreateModalOpen(false);
        }}
        getData={getData}
        // projectId={projectId}

      />
      <MultiEditManpowerbug
        open={multiEditOpen}
        onCancel={() => {
          setMultiEditOpen(false);
        }}
        getData={getData}
        seletedIds={flatSelectedItemIds}
        projectId={projectId}
      />
  </CostingLayout>
  <ImportManPower
        open={open}
        onCancel={() => setOpen(false)}
        getData={getData}
        label="Import"
        projectId={projectId}
      />
       <ImportEstimation
       
       open={importEstimationOpen}
       onCancel={() => setImportEstimationOpen(false)}
        getData={getData}
        label="Import"
        projectId={projectId}
      />
    <Modal
      open={filterOpen}
      title={"Filter Manpower"}
      width={"50%"}
      className="my-modal"
      centered
      onCancel={() => setFilterOpen(false)}
      footer={[]}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className=" w-full flex flex-wrap">
      
          <LongButton value='Filter'/>
        </div>
      </form>
    </Modal>
    {showFilterDialog && (
           
           
           <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
             <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
               <h2 className="text-xl mb-4">Filter Manpower</h2>
               <form onSubmit={formik.handleSubmit}> 
              <div className=" w-full flex flex-wrap">
              <FormikSelectTwo
              type="text"
              label="Category"
              placeholder="Category"
              Options={itemsCategory}
              formik={formik}
              name="category"
              width="w-full "
              // isRequired={true}
            />
</div>
      <div className="flex justify-end gap-2">
                          <CancelButton handleClick={closeFilterDialog} />
                          <SubmitButton name='Apply' />
                        </div>
                       </form> 
                    </div>
                  </div>
                )}
  </>
)
}

export default ManPowerCosting

const header = [
  {
    headone: "ID",
    width: "w-[5%]",
    isLeft: true,
  },
  
  {
    headone: "Designation",
    width: "w-[35%]",
    isLeft: true,
  },
  {
    headone: "Category",
    width: "w-[15%]",
    isLeft: true,

  },
  {
    headone: "Type",
     width: "w-[10%]",
    isLeft: true,

  },
  {
    headone: "Quantity",
    width: "w-[10%]",
      isLeft: true,

  },
  {
    headone: "No. of Days",
   width: "w-[10%]",
    isLeft: true,

  },
  {
    headone: "Total Hours",
    width: "w-[10%]",
    isLeft: true,

  },
  {
    headone: "Action",
    width: "w-[5%]",
    isLeft: true,
  },
];